<div class="main-tabs">
	<div *ngFor="let tab of tabs" class="main-content" (click)="selectTab(tab.title)" [ngClass]="{ selected: tab.isActive, unselected: !tab.isActive }">
		<p>{{ tab.title }}</p>
	</div>
</div>
